import Vue from 'vue'
import VueGtag from 'vue-gtag'
import router from '@/router'

if (['devlive', 'staging', 'production'].includes(process.env.VUE_APP_MODE)) {
  Vue.use(
    VueGtag,
    {
      config: {
        id: process.env.VUE_APP_GOOGLE_ANALYTICS_KEY,
        params: { anonymize_ip: true }
      }
    },
    router
  )
}
